import Icon from '../components/Icon.vue'

Icon.register({
  wrench: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.7 109.1c11.8 47.4-0.8 99.7-37.9 136.7-39.9 39.9-97.3 50.9-147.4 34.2l-213.2 213.2c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5l213.4-213.4c-16.5-50.1-5.6-107.6 34-147.2 37-37 89.2-49.7 136.6-37.9 9.1 2.3 12.3 13.5 5.7 20.2l-74.4 74.4 11.3 67.9 67.9 11.3 74.4-74.4c6.6-6.6 17.9-3.5 20.1 5.5zM64 472c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wrench.js
// module id = 2119
// module chunks = 0